export function viewFor(state, viewer) {
    const players = state.players.map((p) => {
        const { hand, ...rest } = p;
        return {
            ...rest,
            hand: viewer === p.id ? hand : null,
            handCount: hand.length,
        };
    });
    const { hidden: _hidden, rng: _rng, seed: _seed, players: _players, ...publicState } = state;
    return {
        ...publicState,
        viewer,
        players,
        hiddenCounts: {
            drawPile: state.hidden.drawPile.length,
            forumSupply: state.hidden.forumSupply.length,
            bonusBag: state.hidden.bonusBag.length,
            demandSupply: state.hidden.demandSupply.length,
        },
    };
}
//# sourceMappingURL=redact.js.map